const state = {
  loansList: [],
  loansCount: 0,
  isHasMoreLoans: true,
  archivedLoansList: [],
  archivedLoansCount: 0
};

const actions = {
  async getLoansList(context, params) {
    const response = await window.$httpService.loan.getLoansList(params);

    context.commit('setLoansList', response?.data?.rows);
    context.commit('setLoansCount', response?.data?.count);

    if(response.data?.rows.length < (params?.size || 10)) {
      context.commit('setHasMoreLoans', false);
    } else {
      context.commit('setHasMoreLoans', true);
    }
  },
  async getLoansArchivedList(context, params) {
    const response = await window.$httpService.loan.getLoansArchivedList(params);

    context.commit('setArchivedLoansList', response?.data?.rows);
    context.commit('setArchivedLoansCount', response?.data?.count);
  }
};

const mutations = {
  setLoansList(state, data) {
    return state.loansList = data; 
  },
  setLoansCount(state, data) {
    return state.loansCount = data;
  },
  setHasMoreLoans(state, data) {
    state.isHasMoreLoans = data;
  },
  setArchivedLoansList(state, data) {
    state.archivedLoansList = data || [];
  },
  setArchivedLoansCount(state, data) {
    state.archivedLoansCount = data;
  },
};

const getters = {
  loansList(state) {
    return state.loansList;
  },
  loansCount(state) {
    return state.loansCount;
  },
  isHasMoreLoans(state) {
    return state.isHasMoreLoans;
  },
  archivedLoansList(state) {
    return state.archivedLoansList;
  },
  archivedLoansCount(state) {
    return state.archivedLoansCount;
  },
};

export default {
  state,
  actions,
  mutations,
  getters
}